<template>
  <v-flex xs12 class="diy">
    <v-flex xs12 v-if="isLoggedIn" style="padding: 0 5%;">
      <v-flex xs12 v-if="display === 'diyStepper'">
        <v-layout row style="border-bottom: 1px solid grey">
          <v-flex style="flex: none" :class="getBorderBottom(1)" class="stepperHeaders primary--text">Source</v-flex>
          <v-spacer :class="getBorderBottom(2)"></v-spacer>
          <v-flex style="text-align: center; flex: none" :class="getBorderBottom(2)" class="stepperHeaders primary--text">Plan</v-flex>
          <v-spacer :class="getBorderBottom(3)"></v-spacer>
          <v-flex style="text-align: center; flex: none" :class="getBorderBottom(3)" class="stepperHeaders primary--text">Access</v-flex>
          <v-spacer :class="getBorderBottom(4)"></v-spacer>
          <v-flex style="text-align: right; flex: none" :class="getBorderBottom(4)" class="stepperHeaders primary--text">Description</v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="display === 'diyStepper' && step === 1" class="stepContainer">
        <v-flex class="stepContent" v-if="sourcesDisplay === 'sourcesAdd'">
          <v-flex style="flex: none; font-size: 36px; font-weight: 700" class="primary--text">Add one or more sources</v-flex>
          <v-flex style="flex: none; font-size: 18px; font-weight: 300" class="primary--text">Lorem ipsum dolor sit amet, consectetur adipisicing elit</v-flex>
          <v-flex style="flex: none; display: flex; margin-top: 50px">
            <div style="text-align: center" v-if="twitter">
              <v-btn :ripple="false" @click="editTwitter" style="height: 100px; width: 100px" outline fab class="elevation-0" color="primary highlight--text"><img style="max-width: 45px" src="@/assets/twitterOutline.png" /></v-btn>
              <div style="font-size: 18px; margin-top: 10px" class="primary--text">Twitter</div>
              <div style="font-size: 14px; margin-top: 5px; cursor: pointer" @click="editTwitter" class="primary--text">Edit</div>
              <div style="font-size: 14px; margin-top: 5px; color: #FF6767; cursor: pointer" @click="removeTwitter">Remove</div>
            </div>
            <div style="text-align: center" v-if="newsApi">
              <v-btn :ripple="false" @click="editNewsApi" style="height: 100px; width: 100px" outline fab class="elevation-0" color="primary highlight--text"><img style="max-width: 45px" src="@/assets/newsApiOutline.png" /></v-btn>
              <div style="font-size: 18px; margin-top: 10px" class="primary--text">News API</div>
              <div style="font-size: 14px; margin-top: 5px; cursor: pointer" @click="editNewsApi" class="primary--text">Edit</div>
              <div style="font-size: 14px; margin-top: 5px; color: #FF6767; cursor: pointer" @click="removeNewsApi">Remove</div>
            </div>
            <div style="text-align: center" v-if="!twitter || !newsApi">
              <v-btn :ripple="false" @click="sourcesDisplay = 'sourcesList'" style="height: 100px; width: 100px; font-size: 28px" fab class="elevation-0 addBtn" outline color="primary highlight--text">+</v-btn>
              <div style="font-size: 18px; margin-top: 10px" class="primary--text">Add New Source</div>
            </div>
          </v-flex>
        </v-flex>
        <v-flex class="stepContent" v-if="sourcesDisplay === 'sourcesList'">
          <v-flex style="flex: none; font-size: 32px; font-weight: 700" class="primary--text">Choose a source to add</v-flex>
          <v-flex style="flex: none; display: flex; align-items: center; margin-top: 50px">
            <div style="text-align: center" v-if="!twitter">
              <v-btn :ripple="false" @click="openTwitterDialog()" style="height: 100px; width: 100px" fab class="elevation-0" color="primary highlight--text" outline><img style="max-width: 45px" src="@/assets/twitterOutline.png" /></v-btn>
              <div style="font-size: 18px; margin-top: 10px" class="primary--text">Twitter</div>
            </div>
            <div style="text-align: center" v-if="!newsApi">
              <v-btn :ripple="false" @click="addNewsApiDialog = true; newsApiRule = savedNewsApiRule" style="height: 100px; width: 100px" outline fab class="elevation-0" color="primary highlight--text"><img style="max-width: 45px" src="@/assets/newsApiOutline.png" /></v-btn>
              <div style="font-size: 18px; margin-top: 10px" class="primary--text">News API</div>
            </div>
          </v-flex>
        </v-flex>
        <v-flex class="stepActions">
          <v-layout row>
            <v-spacer v-if="sourcesDisplay === 'sourcesList'"></v-spacer>
            <div v-if="sourcesDisplay === 'sourcesList'" @click="sourcesDisplay = 'sourcesAdd'" style="font-size: 18px; cursor: pointer" class="primary--text"><img style="max-height: 15px; margin-right: 10px" src="@/assets/backBtn.png" />Back</div>
            <v-spacer></v-spacer>
            <v-btn flat :ripple="false" round class="primary" dark @click="step = 2" v-if="sourcesDisplay === 'sourcesAdd'" :disabled="!twitter && !newsApi">Next<img src="@/assets/next.png" style="max-height: 15px; margin-left: 10px" /></v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex v-if="display === 'diyStepper' && step === 2" class="stepContainer">
        <v-flex xs12 class="stepContent">
          <div style="font-size: 36px; font-weight: 700;" class="primary--text">Choose a plan to subscribe to</div>
          <v-flex xs12 style="display: flex; align-items: center; justify-content: center; height: 400px; width: 100%">
            <v-flex v-for="item in getDiyPlans" class="diyPLan pa-1 mx-5" :key="item.id" v-if="Number(item.tier) !== 0 || isMaster">
              <div class="diyPlanHeader primary--text">
                {{item.displayName}}
              </div>
              <div class="py-3 primary--text" style="font-size: 48px; font-weight: 300">{{ '$' + item.fixedFee}} <span style="font-size: 18px; font-weight: 500" class="primary--text" v-if="Number(item.tier) !== 0">{{' /' + getPeriod(item.period)}}</span></div>
              <div style="font-size: 14px; margin-top: 20px" class="primary--text">Includes:</div>
              <ul style="padding-left: 18px">
                <li class="primary--text">{{getNumber(item.maxTweets)}} tweets</li>
                <li class="primary--text">{{getNumber(item.maxArticles)}} articles</li>
                <li class="primary--text">{{item.description}}</li>
              </ul>
              <v-btn v-if="!edit || diyPlan === null || diyPlan !== item.id" flat outline round color="primary" dark :ripple="false" style="font-size: 18px; text-transform: none; width: 100%; margin: 0; margin-top: 20px" @click="diyPlan = item.id; step = 3" :disabled="isMaster && Number(item.tier) !== 0">Choose Plan</v-btn>
              <div v-else-if="edit === true && diyPlan !== null && diyPlan === item.id" style="font-size: 18px; text-transform: none; width: 100%; margin: 0; margin-top: 20px; text-align: center; border: 1px solid #2165FF; height: 45px; line-height: 45px; border-radius: 50px; color: #2165FF">Selected</div>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex class="stepActions">
          <v-layout row>
            <div @click="step = 1" style="height: 45px; display: flex; align-items: center; font-size: 18px; cursor: pointer" class="primary--text"><img src="@/assets/back.png" style="max-height: 15px; margin-right: 10px" />Back</div>
            <v-spacer></v-spacer>
            <v-btn flat :ripple="false" round class="primary" dark @click="step = 3" v-if="edit && diyPlan !== null">Next<img src="@/assets/next.png" style="max-height: 15px; margin-left: 10px" /></v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex v-if="display === 'diyStepper' && step === 3" class="stepContainer">
        <v-flex class="stepContent">
          <v-flex style="flex: none; font-size: 36px; font-weight: 700;" class="primary--text">Add users to your project</v-flex>
          <v-flex style="display: flex; align-items: flex-start; flex-direction: column; justify-content: flex-start; width: 70%; margin-top: 50px">
            <div style="display: flex; align-items: center" @click="usersAddDialog = true">
              <v-btn large style="height: 73px; width: 73px; font-size: 28px; margin: 0" fab class="elevation-0 addBtn" outline color="primary highlight--text">+</v-btn>
              <div style="font-size: 18px; font-weight: 700; padding-left: 10px" class="primary--text">Add new user</div>
            </div>
            <v-layout row wrap style="margin-top: 50px">
              <v-flex style="flex: none; display: flex; align-items: center; margin-right: 20px">
                <img style="max-width: 73px" src="@/assets/user.png" />
                <div style="padding-left: 10px; height: 100%">
                  <v-flex style="font-size: 18px; font-weight: 700" class="primary--text">{{currentUser.firstName + ' ' + currentUser.lastName}}</v-flex>
                  <v-flex style="font-size: 14px" class="primary--text">{{getUserRole(currentUser.id)}}</v-flex>
                  <v-flex style="font-size: 14px" class="primary--text">(Default)</v-flex>
                </div>
              </v-flex>
              <v-flex style="flex: none; display: flex; align-items: center; margin-right: 20px" v-for="item in organizationAdminsWithoutCurrentUser" :key="item.id" v-if="currentUser && item.id !== currentUser.id">
                <img style="max-width: 73px" src="@/assets/user.png" />
                <div style="padding-left: 10px; height: 100%">
                  <v-flex class="primary--text" style="font-size: 18px; font-weight: 700">{{item.firstName + ' ' + item.lastName}}</v-flex>
                  <v-flex class="primary--text" style="font-size: 14px">{{getUserRole(item.id)}}</v-flex>
                </div>
              </v-flex>
              <v-flex style="flex: none; display: flex; align-items: center; margin-right: 20px" v-for="(item, index) in getUsersByIds" :key="index">
                <img style="max-width: 73px" src="@/assets/user.png" />
                <div style="padding-left: 10px; height: 100%">
                  <v-flex class="primary--text" style="font-size: 18px; font-weight: 700">{{item.firstName + ' ' + item.lastName}}</v-flex>
                  <v-flex class="primary--text" style="font-size: 14px">{{getUserRole(item.id)}}</v-flex>
                </div>
                <v-btn small icon :ripple="false" light @click="userIds.splice(index, 1)" style="text-align: right; position: relative; padding: 0px; margin: 0px; margin-left: 15px;">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
              <v-flex style="flex: none; display: flex; align-items: center; margin-right: 20px" v-for="(item, index) in invitedUsersArray" :key="index" v-if="item.email != ''">
                <img style="max-width: 73px" src="@/assets/user.png" />
                <div style="padding-left: 10px; height: 100%">
                  <v-flex class="primary--text" style="font-size: 18px; font-weight: 700">{{item.email}}</v-flex>
                  <v-flex class="primary--text" style="font-size: 14px">{{item.isAdmin ? 'Administrator' : 'Viewer'}}</v-flex>
                  <v-flex class="primary--text" style="font-size: 14px">(Invitation)</v-flex>
                </div>
                <v-btn small icon :ripple="false" light @click="invitedUsersArray.splice(index, 1)" style="text-align: right; position: relative; padding: 0px; margin: 0px; margin-left: 15px;">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
        <v-flex class="stepActions">
          <v-layout row>
            <div @click="step = 2" style="height: 45px; display: flex; align-items: center; font-size: 18px; cursor: pointer" class="primary--text"><img src="@/assets/back.png" style="max-height: 15px; margin-right: 10px" />Back</div>
            <v-spacer></v-spacer>
            <v-btn flat :ripple="false" round class="primary" @click="step = 4">Next<img src="@/assets/next.png" style="max-height: 15px; margin-left: 10px" /></v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
      <v-flex v-if="display === 'diyStepper' && step === 4" class="stepContainer">
        <v-flex xs12 class="stepContent projectInfoTab">
          <v-flex style="flex: none; font-size: 36px; font-weight: 700; text-align: center" class="primary--text">Project Description</v-flex>
          <div style="flex: none;width: 100%; display: flex; align-items: center; flex-direction: column; margin-top: 50px">
            <v-layout style="width: 70%" row mt-5>
              <v-flex xs3 :class="projectNameLoading === 'invalid' ? 'error--text' : 'primary--text'" style="font-size: 18px">Project Name</v-flex>
              <v-flex xs9 style="border-radius: 50px; border: 1px solid #011E41"><v-text-field solo flat hide-details v-model="name" :error="projectNameLoading === 'invalid'" :success="projectNameLoading === 'valid'" @input="validateProjectName"></v-text-field></v-flex>
            </v-layout>
            <v-layout style="width: 70%" row class="mt-4">
              <v-flex xs3 class="primary--text" style="font-size: 18px">Project Description</v-flex>
              <v-flex xs9 style="border-radius: 30px; border: 1px solid #011E41"><v-textarea auto-grow solo flat v-model="description" hide-details></v-textarea></v-flex>
            </v-layout>
            <v-layout style="width: 70%" row class="mt-4">
              <v-flex xs3 class="primary--text" style="font-size: 18px">Categories</v-flex>
              <v-flex xs9 style="border-radius: 30px"><v-chip style="cursor: pointer" @click="handleCategories(item)" v-for="(item, index) in getProjectCategories" :class="categories.indexOf(item) === -1 ? 'primary secondary--text' : 'chipSelected secondary--text'" :key="index" v-if="item !== 'trending'">{{item}}</v-chip></v-flex>
            </v-layout>
            <v-layout style="width: 70%" row class="mt-4">
              <v-flex xs3 class="primary--text" style="font-size: 18px">Public Status</v-flex>
              <v-flex xs9 style="border-radius: 30px">
                <v-radio-group v-model="isPublic" style="margin-top: 0; height: 30px">
                  <v-layout row>
                    <v-radio color="primary"
                      label="Keep Private"
                      :value="0"
                    ></v-radio>
                    <v-radio color="primary"
                      label="Publish"
                      :value="1"
                    ></v-radio>
                  </v-layout>
                </v-radio-group>
                <div style="font-size: 14px; font-weight: 300" class="primary--text">By choosing to <span style="color: #2165FF !important">publish your project to Yakshof Market</span>, any organization will be able to view and subscribe to your project.</div>
              </v-flex>
            </v-layout>
            <v-layout style="width: 70%" row class="mt-4">
              <v-flex xs3 class="primary--text" style="font-size: 18px">Cover Photo</v-flex>
              <v-flex xs6 style="border-radius: 30px; border: 1px solid #011E41"><v-text-field prepend-icon="search" solo flat hide-details class="elevation-0" placeholder="Search for photos here by typing keywords and clicking the search icon" v-model="photosSearchQuery" @click:prepend="searchForPhotos" v-on:keyup.enter="searchForPhotos"></v-text-field></v-flex>
              <v-flex xs3 class="primary--text text-xs-right" style="font-size: 14px">This search is provided by <a href="http://www.unsplash.com" target="_blank">Unsplash</a></v-flex>
            </v-layout>
            <v-layout style="width: 70%" row class="mt-4">
              <v-flex xs3 class="primary--text" style="font-size: 18px">&nbsp;</v-flex>
              <v-flex xs9>
                <v-container grid-list-sm fluid v-if="!config.unsplashImageUrl || config.unsplashImageUrl == null">
                  <v-layout row wrap>
                    <v-flex v-for="photo in photos" :key="photo.id" xs3 d-flex @click="unsplashImageUrl = photo.urls.regular" style="cursor: pointer;">
                      <v-img :src="photo.urls.regular + '?w=150&h=150'" class="grey lighten-2" min-width="150" height="150" :style="unsplashImageUrl === photo.urls.regular ? 'border: 3px solid #2165FF !important;' : 'border: 3px solid transparent !important;'"></v-img>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container grid-list-sm fluid v-if="config.unsplashImageUrl && config.unsplashImageUrl.length > 0">
                  <v-layout row wrap>
                    <v-flex xs3 d-flex style="cursor: pointer;">
                      <v-img :src="config.unsplashImageUrl + '?w=150&h=150'" class="grey lighten-2" min-width="150" height="150" :style="(!unsplashImageUrl || unsplashImageUrl == null) ? 'border: 3px solid #2165FF !important;' : 'border: 3px solid transparent !important;'"></v-img>
                    </v-flex>
                    <v-flex v-for="photo in photos" :key="photo.id" xs3 d-flex @click="unsplashImageUrl = photo.urls.regular" style="cursor: pointer;">
                      <v-img :src="photo.urls.regular + '?w=150&h=150'" class="grey lighten-2" min-width="150" height="150" :style="unsplashImageUrl === photo.urls.regular ? 'border: 3px solid #2165FF !important;' : 'border: 3px solid transparent !important;'"></v-img>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex class="stepActions">
          <v-layout row>
            <div @click="step = 3" style="height: 45px; display: flex; align-items: center; font-size: 18px; cursor: pointer" class="primary--text"><img src="@/assets/back.png" style="max-height: 15px; margin-right: 10px" />Back</div>
            <v-spacer></v-spacer>
            <v-btn flat :disabled="(!unsplashImageUrl && !config.unsplashImageUrl) || name === '' || categories.length === 0 || description === '' || projectNameLoading !== 'valid'" :ripple="false" round class="primary" @click="summaryDialog = true">next</v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex xs12 v-if="!isLoggedIn" class="diyExplained">
      <div class="xs12 diyExplainedTitle primary--text">The project tailored for your needs.</div>
      <v-layout row wrap mt-5>
        <v-flex xs7>
          <img src="@/assets/diyExplained.png" style="max-width: 100%"/>
        </v-flex>
        <v-flex xs5 style="display: flex; flex-direction: column; justify-content: center">
          <div style="font-size: 28px; font-weight: 800; padding-left: 80px; margin-bottom: 20px;" class="primary--text">Control</div>
          <div style="font-size: 22px; font-weight: 300; padding-left: 80px;" class="primary--text">Source</div>
          <div style="font-size: 22px; font-weight: 300; padding-left: 80px;" class="primary--text">Volume</div>
          <div style="font-size: 22px; font-weight: 300; padding-left: 80px;" class="primary--text">Budget</div>
        </v-flex>
        <v-flex xs5 mt-5 style="display: flex; flex-direction: column; justify-content: center">
          <div style="font-size: 28px; font-weight: 800; padding-right: 80px; margin-bottom: 20px;" class="primary--text">Earn</div>
          <div style="font-size: 22px; font-weight: 300; padding-right: 80px;" class="primary--text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
        </v-flex>
        <v-flex xs7 mt-5>
          <img src="@/assets/diyExplained.png" style="max-width: 100%"/>
        </v-flex>
        <v-flex xs7 mt-5>
          <img src="@/assets/diyExplained.png" style="max-width: 100%"/>
        </v-flex>
        <v-flex xs5 mt-5 style="display: flex; flex-direction: column; justify-content: center">
          <div style="font-size: 28px; font-weight: 800; padding-left: 80px; margin-bottom: 20px;" class="primary--text">Share</div>
          <div style="font-size: 22px; font-weight: 300; padding-left: 80px;" class="primary--text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-if="!isLoggedIn" class="highlight">
      <div style="height: 400px; display: flex; align-items: center; justify-content: center; flex-direction: column">
        <div style="font-size: 24px; font-weight: 300" class="accent--text">Create it the way you like it.</div>
        <div style="font-size: 38px; font-weight: 800" class="primary--text">Take control, and apply your preferences.</div>
        <v-btn round :ripple="false" flat @click="$router.push({ path: '/login', query: { path: '/diy' } })" class="diyLoginButton primary secondary--text">Login</v-btn>
      </div>
    </v-flex>
    <v-dialog v-model="addTwitterDialog" fullscreen transition="dialog-transition">
      <v-card class="twitterDialog">
        <v-card-text>
          <v-flex xs12 class="secondary pa-4">
            <v-flex style="position: relative; width: 100%; height: 100%">
              <v-flex xs12 style="text-align: center; font-size: 36px;" class="primary--text">Please specify <b>twitter</b> parameters</v-flex>
              <v-btn small icon :ripple="false" light @click="clearTwitterForms" style="text-align: right; position: absolute; top: -23px; right: -23px; padding: 0; margin: 0">
                <v-icon>close</v-icon>
              </v-btn>
              <div class="twitterSlider">
                <div @click="switchToSimpleTwitterDisplay" :class="addTwitterDialogDisplay === 'simple' ? 'selected' : ''">Standard</div>
                <div @click="switchToAdvancedTwitterDisplay" :class="addTwitterDialogDisplay === 'advanced' ? 'selected' : ''">Advanced</div>
              </div>
              <v-flex xs12 class="mt-3" v-if="addTwitterDialogDisplay === 'simple'" style="padding: 0 10%">
                <v-flex xs12 style="text-align: center; font-size: 14px" class="primary--text">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</v-flex>
                <v-layout row mt-5>
                  <v-flex xs2 class="twitterFormHeader primary--text">Twitter Users:</v-flex>
                  <v-flex xs10 pl-3>
                    <v-flex xs12 class="twitterFormInput">
                      <v-layout row wrap px-1 py-1>
                        <span style="display: flex; align-items: center" v-for="(item, index) in twitterUsers" :key="index">
                          <v-chip color="white--text" class="mr-1 mb-1" small close @input="handleTwitterUsersChips(item)">{{item}}</v-chip>
                        </span>
                        <v-text-field autofocus solo flat hide-details v-on:keyup.enter='addTwitterUser' v-on:keyup.space='addTwitterUser' v-model="twitterUsersField"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pl-2 caption class="primary--text">
                      Hit space or enter to add user.
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout row mt-3>
                  <v-flex xs2 class="twitterFormHeader primary--text">Mentions:</v-flex>
                  <v-flex xs10 pl-3>
                    <v-flex xs12 class="twitterFormInput">
                      <v-layout row wrap px-1 py-1>
                        <span style="display: flex; align-items: center" v-for="(item, index) in mentions" :key="index">
                          <v-chip color="white--text" class="mr-1 mb-1" small close @input="handleMentionsChips(item)">{{item}}</v-chip>
                        </span>
                        <v-text-field autofocus solo flat hide-details v-on:keyup.space='addMention' v-on:keyup.enter='addMention' v-model="mentionsField"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pl-2 caption class="primary--text">
                      Hit space or enter to add mention.
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout row mt-3>
                  <v-flex xs2 class="twitterFormHeader primary--text">Hashtags:</v-flex>
                  <v-flex xs10 pl-3>
                    <v-flex xs12 class="twitterFormInput">
                      <v-layout row wrap px-1 py-1>
                        <span pa-0 style="display: flex; align-items: center" v-for="(item, index) in hashtags" :key="index">
                          <v-chip color="white--text" class="mr-1 mb-1" small close @input="handleHashtagsChips(item)">{{item}}</v-chip>
                        </span>
                        <v-text-field solo flat hide-details v-on:keyup.enter='addHashtag' v-on:keyup.space='addHashtag' v-model="hashtagsField"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pl-2 caption class="primary--text">
                      Hit space or enter to add hashtag.
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout row mt-3>
                  <v-flex xs2 class="twitterFormHeader primary--text">Keywords:</v-flex>
                  <v-flex xs10 pl-3>
                    <v-flex xs12 class="twitterFormInput">
                      <v-layout row wrap px-1 py-1>
                        <span style="display: flex; align-items: center" v-for="(item, index) in keywords" :key="index">
                          <v-chip color="white--text" class="mr-1 mb-1" small close @input="handleKeywordsChips(item)">{{item}}</v-chip>
                        </span>
                        <v-text-field solo flat hide-details v-on:keyup.enter='addKeyword' v-on:keyup.space='addKeyword' v-model="keywordsField"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pl-2 caption class="primary--text">
                      Hit space or enter to add keyword.
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout row mt-3>
                  <v-flex xs2 class="twitterFormHeader primary--text">Location:</v-flex>
                  <v-flex xs10 pl-3>
                    <v-flex xs12 class="twitterFormInput">
                      <v-layout row wrap px-1 py-1>
                        <span style="display: flex; align-items: center" v-for="(item, index) in location" :key="index">
                          <v-chip color="white--text" class="mr-1 mb-1" small close @input="handleLocationChips(item)">{{item}}</v-chip>
                        </span>
                        <v-text-field solo flat hide-details v-on:keyup.enter='addLocation' v-on:keyup.space='addLocation' v-model="locationField"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pl-2 caption class="primary--text">
                      Hit space or enter to add location.
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout row mt-3>
                  <v-flex xs2 class="twitterFormHeader primary--text">Language:</v-flex>
                  <v-flex xs10 pl-3>
                    <v-flex xs12 class="twitterFormInput">
                      <v-layout row wrap px-1 py-1>
                        <span style="display: flex; align-items: center" v-for="(item, index) in language" :key="index">
                          <v-chip color="white--text" class="mr-1 mb-1" small close @input="handleLanguageChips(item)">{{item}}</v-chip>
                        </span>
                        <v-text-field solo flat hide-details v-on:keyup.enter='addLanguage' v-on:keyup.space='addLanguage' v-model="languageField"></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pl-2 caption class="primary--text">
                      Hit space or enter to add language.
                    </v-flex>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row mt-3>
                  <v-flex xs4>
                    <div class="twitterFormHeader">
                      Retweets Only
                      <v-checkbox :ripple="false" color="primary" class="ml-1" v-model="retweetsOnly"></v-checkbox>
                    </div>
                  </v-flex>
                  <v-flex xs4>
                    <div class="twitterFormHeader">
                      Quotes Only
                      <v-checkbox :ripple="false" color="primary" class="ml-1" v-model="quotesOnly"></v-checkbox>
                    </div>
                  </v-flex>
                  <v-flex xs4>
                    <div class="twitterFormHeader">
                      Verified Users Only
                      <v-checkbox :ripple="false" color="primary" class="ml-1" v-model="verifiedOnly"></v-checkbox>
                    </div>
                  </v-flex>
                </v-layout> -->
                <v-flex style="display: flex; align-items: center; justify-content: center" mt-4>
                  <v-btn class="primary" flat round :ripple="false" @click="addTwitterSource('simple')">Add Twitter</v-btn>
                </v-flex>
              </v-flex>
              <v-flex xs12 class="mt-3" v-if="addTwitterDialogDisplay === 'advanced'" style="padding: 0 10%">
                <v-flex style="text-align: center" class="primary--text">This section is for professionals to add advanced twitter parameters.<br>Please refer to the <a target="_blank" href="https://developer.twitter.com/en/docs/tweets/rules-and-filtering/overview/premium-operators#listofoperators" style="text-decoration: none; color: #2165FF">Advanced Twitter Parameters List</a>.</v-flex>
                <v-form class="twitterAdvancedForm mt-5">
                  <v-text-field style="width: 90%" solo flat hide-details v-model="twitterAdvancedRules[0]"></v-text-field>
                  <v-layout class="mt-2" style="width: 100%" v-for="(item, index) in twitterAdvancedRules" v-if="index !== 0" :key="index">
                    <v-text-field style="width: 90%" solo flat hide-details v-model="twitterAdvancedRules[index]"></v-text-field>
                    <div style="width: 10%; display: flex; align-items: center; justify-content: center; cursor: pointer" @click="twitterAdvancedRules.splice(index, 1)"><img src="@/assets/remove.png" style="max-height: 10px" /></div>
                  </v-layout>
                  <div @click="twitterAdvancedRules.push('')" style="padding: 30px 0; font-size: 18px; display: flex; align-items: center; cursor: pointer" class="primary--text"><img src="@/assets/add.png" style="width: 22px; height: 22px; margin-right: 5px" />Add another rule</div>
                </v-form>
                <v-flex mt-3 style="display: flex; align-items: center; justify-content: center">
                  <v-btn class="primary" @click="addTwitterSource('advanced')" flat round :ripple="false">Add Twitter</v-btn>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addNewsApiDialog"
      persistent
      fullscreen
      transition="dialog-transition">
      <v-card>
        <v-card-text>
          <v-flex xs12 class="secondary pa-4 newsApiDialog">
            <v-flex style="position: relative; width: 100%; height: 100%; padding: 0 10%">
              <v-btn small icon :ripple="false" light @click="addNewsApiDialog = false; newsApiRule = ''" style="text-align: right; position: absolute; top: -23px; right: -23px; padding: 0; margin: 0">
                <v-icon>close</v-icon>
              </v-btn>
              <v-flex xs12 style="text-align: center; font-size: 36px;" class="primary--text">Please specify <b>News API</b> rules</v-flex>
              <v-flex style="text-align: center;margin-top: 60px" class="mb-5 primary--text">This section is for adding News API parameters.<br>Please refer to the <a target="_blank" href="https://newsapi.org/docs/endpoints/everything" style="text-decoration: none; color: #2165FF">Advanced News API Parameters List</a>.</v-flex>
              <v-text-field class="round mt-3" solo flat hide-details v-model="newsApiRule" @keyup.enter="addNewsApi"></v-text-field>
              <v-flex mt-5 style="display: flex; align-items: center; justify-content: center">
                <v-btn class="primary" style="width: 160px; height: 45px" flat round :ripple="false" @click="addNewsApi()">Add News API</v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="usersAddDialog"
      fullscreen
      transition="dialog-transition">
      <v-card>
        <v-card-text>
          <v-flex xs12 class="secondary pa-4 newsApiDialog">
            <v-flex v-if="addUserDialogDisplay === 'add'" style="position: relative; width: 100%; height: 100%; padding: 0 10%">
              <v-btn small icon light @click="usersAddDialog = false" style="text-align: right; position: absolute; top: -23px; right: -23px; padding: 0; margin: 0">
                <v-icon>close</v-icon>
              </v-btn>
              <v-flex xs12 style="text-align: center; font-size: 36px;" class="primary--text">Add users to Project</v-flex>
              <v-layout row style="margin-top: 60px">
                <v-autocomplete color="primary" hide-details solo v-if="getUserOrganization" :items="organizationViewersWithoutCurrentUser" v-model="userIds" label="Search by name" item-text="firstName" item-value="id" multiple small-chips deletable-chips :menu-props="{maxHeight:'auto'}" class="usersSearch">
                  <template slot="users" slot-scope="data" v-if="data.item.id !== currentUser.id && Number(getUserRoleId(data.item.id)) !== Number(adminRoleId) && Number(getUserRoleId(data.item.id)) !== Number(masterRoleId)">
                    <v-chip :selected="data.users" :key="JSON.stringify(data.item)" close class="chip--select-multi" style="background-color: #2165FF" @input="data.parent.selectItem([data.users.item])">
                      {{ data.item.firstName }} {{ data.item.lastName }}
                    </v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.firstName + ' ' + data.item.lastName"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="data.item.email"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-autocomplete>
                <v-flex style="flex: none;display: flex; align-items: center; justify-content: center">
                  <v-btn class="primary" @click="saveUsers()" flat round :ripple="false" style="text-transform: capitalize">Add</v-btn>
                </v-flex>
              </v-layout>
              <v-divider class="my-5"></v-divider>
              <v-flex pb-4 v-if="isLoggedIn && isAdmin" class="text-xs-center primary--text" style="font-size: 16px">
                Or, <span @click="addUserDialogDisplay = 'invite'" style="cursor: pointer">invite a new user to <b>{{getUserOrganization.name}}</b></span>
              </v-flex>
            </v-flex>
            <v-flex v-if="addUserDialogDisplay === 'invite'" style="position: relative; width: 100%; height: 100%;">
              <v-btn small icon light @click="usersAddDialog = false; addUserDialogDisplay = 'add'" style="text-align: right; position: absolute; top: -23px; right: -23px; padding: 0; margin: 0">
                <v-icon>close</v-icon>
              </v-btn>
              <v-flex xs12 style="text-align: center; font-size: 36px;" class="primary--text">Invite new users to <b>{{getUserOrganization.name}}</b></v-flex>
              <v-form class="inviteUsersForm" style="padding: 0 10%">
                <v-flex xs12 mt-4 v-for="(email, index) in invitedUsers" :key="index">
                  <v-layout row style="display: flex; align-items: center">
                    <v-text-field style="width: 70%" placeholder="name@example.com" :ref="'userInvitationEmailField_'+index" :rules="[rules.email]" class="round" solo flat v-model="invitedUsers[index].email"></v-text-field>
                    <v-flex style="flex: none;display: flex; align-items: center; width: 30%">
                      <v-checkbox style="width: 50%; flex: none" :ripple="false" color="primary" class="ml-2 noBorder cbxLabel" label="Admin" v-model="invitedUsers[index].isAdmin" hide-details></v-checkbox>
                      <div v-if="index !== 0" style="flex: none;width: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer" @click="invitedUsers.splice(index, 1)"><img src="@/assets/remove.png" style="max-height: 10px" /></div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <div @click="addNewEmailInvitationField" style="padding: 30px 0; font-size: 18px; display: flex; align-items: center; cursor: pointer" class="primary--text"><img src="@/assets/add.png" style="width: 22px; height: 22px; margin-right: 5px" />Add another email.</div>
              </v-form>
              <v-flex mt-3 style="display: flex; align-items: center; justify-content: center">
                <v-btn class="primary" @click="inviteUsers()" flat round :ripple="false">Invite Users</v-btn>
              </v-flex>
              <v-divider class="my-5"></v-divider>
              <v-flex pb-4 v-if="isLoggedIn" class="text-xs-center primary--text" style="font-size: 16px">
                Or, <span @click="addUserDialogDisplay = 'add'" style="cursor: pointer">add existing users</span>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="summaryDialog"
      persistent
      fullscreen
      transition="dialog-transition"
      v-if="summaryDialog">
      <v-card>
        <v-card-text>
          <v-flex xs12 class="secondary pa-4 newsApiDialog">
            <v-flex style="position: relative; width: 100%; height: 100%; padding: 0 15%">
              <v-btn small icon :ripple="false" light @click="summaryDialog = false" style="text-align: right; position: absolute; top: -23px; right: -23px; padding: 0; margin: 0">
                <v-icon>close</v-icon>
              </v-btn>
              <v-flex v-if="config.unsplashImageUrl && config.unsplashImageUrl !== null">
                <img :src="config.unsplashImageUrl" style="height: 200px; margin-bottom: 20px">
              </v-flex>
              <v-flex v-else-if="unsplashImageUrl && unsplashImageUrl !== null">
                <img :src="unsplashImageUrl" style="height: 200px; margin-bottom: 20px">
              </v-flex>
              <v-flex xs12 style="font-size: 36px;" class="primary--text">Summary</v-flex>
              <v-flex style="margin-top: 10px; font-size: 18px" class="mb-5 primary--text">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut.</v-flex>
              <div style="font-size: 24px; font-weight: 700" v-if="twitter" class="primary--text">Twitter Parameters</div>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length === 0 && twitterRules.twitterUsers.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Twitter Users</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.twitterUsers" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length === 0 && twitterRules.mentions.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Mentions</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.mentions" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length === 0 && twitterRules.hashtags.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Hashtags</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.hashtags" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length === 0 && twitterRules.keywords.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Keywords</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.keywords" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length === 0 && twitterRules.location.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Location</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.location" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length === 0 && twitterRules.language.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Language</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.language" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <v-layout mt-3 row v-if="twitter && twitterRules.twitterAdvancedRules.length > 0">
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Rules</div>
                <div>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in twitterRules.twitterAdvancedRules" :key="index">{{item}}</div>
                </div>
              </v-layout>
              <div style="font-size: 24px; font-weight: 700" v-if="newsApi" class="primary--text">News API Rule</div>
              <v-layout mt-3 row v-if="newsApi">
                <div class="primary--text" style="font-size: 18px; margin-right: 20px">{{savedNewsApiRule}}</div>
              </v-layout>
              <div style="font-size: 24px; font-weight: 700;"  class="primary--text mt-5 mb-4">Plan</div>
              <div>
                <div class="primary--text" style="font-size: 18px; font-weight: 700">
                  {{getPlanById(diyPlan).displayName}}
                </div>
                <div class="py-1 primary--text" style="font-size: 48px; font-weight: 300">{{ '$' + getPlanById(diyPlan).fixedFee}} <span style="font-size: 18px; font-weight: 500" class="primary--text" v-if="Number(getPlanById(diyPlan).tier) !== 0">{{' /' + getPeriod(getPlanById(diyPlan).period)}}</span></div>
                <div style="font-size: 14px; margin-top: 10px" class="primary--text">Includes:</div>
                <ul style="padding-left: 18px">
                  <!-- <li style="font-size: 14px" class="bulletPoint primary--text">{{getMaxUsers(getPlanById(diyPlan).maxUsers) + ' users'}}</li> -->
                  <li class="primary--text">{{getPlanById(diyPlan).description}}</li>
                </ul>
              </div>
              <div style="font-size: 24px; font-weight: 700;"  class="primary--text mt-5 mb-4">Users <span style="font-weight: 300">{{numberOfUsers}}</span></div>
              <v-layout row>
                <div class="primary--text" style="font-size: 18px; margin-right: 20px; font-weight: 700" v-for="(item, index) in getAllUsers" :key="index">{{item}}</div>
              </v-layout>
              <div style="font-size: 24px; font-weight: 700;"  class="primary--text mt-5 mb-4">Overview</div>
              <v-layout mt-3 row>
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Name</div>
                <div class="primary--text" style="font-size: 18px; margin-right: 20px">{{name}}</div>
              </v-layout>
              <v-layout mt-3 row>
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Description</div>
                <div class="primary--text" style="font-size: 18px; margin-right: 20px">{{description}}</div>
              </v-layout>
              <v-layout mt-3 row>
                <div style="min-width: 160px; font-size: 18px; font-weight: 700" class="primary--text">Categories</div>
                <v-layout row>
                  <div class="primary--text" style="font-size: 18px; margin-right: 20px" v-for="(item, index) in categories" :key="index">{{item}}</div>
                </v-layout>
              </v-layout>
              <div class="mt-5 primary--text" style="font-size: 14px">By choosing “Confirm Project” you agree to <span style="color: #2165FF !important">Yakshof Market privacy policy</span>, and <span style="color: #2165FF !important">Terms of use.</span></div>
              <v-flex mt-3 style="display: flex; align-items: center;">
                <v-btn class="primary" style="width: 160px; height: 45px; margin-right: 20px" flat round :ripple="false" @click="submit" :loading="loading">Confirm Project</v-btn>
                <v-btn class="primary" style="width: 160px; height: 45px" flat outline round :ripple="false" @click="summaryDialog = false">Edit</v-btn>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="successDialog"
      persistent
      fullscreen
      transition="dialog-transition">
      <v-card>
        <v-card-text>
          <v-flex xs12 class="secondary pa-4 newsApiDialog">
            <v-flex style="position: relative; width: 100%; height: 100%; padding: 10%">
              <div style="text-align: left">
                <img src="@/assets/check.png" style="margin-bottom: 20px; max-height: 190px; margin: 0; padding: 0">
                <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">You're all set!</v-flex>
                <v-flex xs12 style="font-size: 18px;" class="primary--text">We’ll notify you once your project is approved and ready.</v-flex>
                <v-btn style="width: 160px; height: 45px" flat round class="mt-5 primary doneBtn" :ripple="false" @click="$router.push('/home')">Done</v-btn>
              </div>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<style>
.inviteUsersForm .v-input__slot{
  height: 45px;
  margin: 0 !important;
}
.inviteUsersForm input{
  padding-top: 0 !important
}
.chipSelected{
  background-color: #2165FF !important;
}
.cbxLabel .v-label{
  color: #011E41;
}
.cbxLabel {
  height: 60px !important;
  margin-top: 0px !important;
}
.usersSearch .v-input__slot{
  box-shadow: none !important;
}
.twitterSlider{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px
}
.twitterSlider div{
  border: 1px solid #011E41;
  font-size: 18px;
  text-transform: capitalize;
  width: 140px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.twitterSlider div.selected{
  background-color: #011E41 !important;
  color: white !important;
}
.twitterSlider div:nth-child(1){
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}
.twitterSlider div:nth-child(2){
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}
.diy .v-btn:hover:before, .twitterDialog .v-btn:hover:before{
  background-color: transparent !important;
}
.diy button:disabled{
  background-color: #B2BBC5 !important;
  color: white !important;
}
.diy button:disabled .v-btn__content{
  color: white !important;
}
.diy .theme--dark.v-btn.v-btn--disabled .v-icon{
  color: white !important;
}
.diy button, .twitterDialog button{
  height: 45px;
  width: 160px;
}
.diy button .v-btn__content{
  font-size: 18px;
  text-transform: capitalize !important;
}
.twitterDialog button .v-btn__content{
  font-size: 18px;
  text-transform: capitalize !important;
}
.addBtn .v-btn__content{
  font-size: 36px !important
}
.diyExplainedTitle{
  font-size: 38px;
  font-weight: bold;
  text-align: center;
}
.diyExplained {
  padding: 50px 5%;
}
.borderBottomHighlight{
  border-bottom: 2px solid grey;
  transition: all ease 300ms;
  font-weight: 700;
}
.stepperHeaders{
  font-size: 16px;
  padding: 10px 0;
}
.stepContainer{
  margin-top: 120px
}
.stepContent{
  height: 85%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.projectInfoTab{
  /*display: block;*/
}
.diyLoginButton{
  padding: 0 40px;
  height: 50px;
}
.twitterFormHeader{
  display: flex;
  align-items: center;
  font-size: 18px
}
.twitterFormInput{
  border-radius: 50px;
  border: 1px solid #011E41 !important;
}
.twitterFormInput .theme--light.v-text-field--solo .v-input__slot, .projectInfoTab .theme--light.v-text-field--solo .v-input__slot{
  background: transparent !important;
  padding-left: 5px;
}
.twitterFormInput .v-text-field, .projectInfoTab .v-text-field{
  border-radius: 50px;
}
.twitterFormInput .v-input__control{
  min-height: auto !important
}
.twitterFormInput .v-chip{
  margin: 0;
  padding: 0;
  margin-bottom: 0 !important;
  height: 32px !important;
  background-color: #2165FF !important;
}
.usersSearch .v-chip{
  background-color: #2165FF !important;
  color: white !important;
}
.twitterAdvancedForm .v-input__slot, .newsApiDialog .v-input__slot{
  background-color: transparent !important;
}
.twitterAdvancedForm .v-input, .newsApiDialog .v-input{
  border-radius: 50px;
  border: 1px solid #011E41 !important;
}
.newsApiDialog .v-input{
  height: 45px !important
}
.diyPLan{
  border-radius: 10px;
  max-width: 200px;
  cursor: pointer;
}
.diyPlanHeader{
  font-size: 18px;
  font-weight: 800
}
.stepActions{
  margin-top: 80px;
  margin-bottom: 80px;
}
.inviteUsersForm .v-text-field.v-text-field--solo .v-input__control{
  min-height: 20px !important
}
.inviteUsersForm input{
  padding-bottom: 0
}
.noBorder.v-input{
  border: none !important;
}
</style>

<script>
import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import vh, { name, description, configNewsapi } from '@/helpers/validators'
import axios from 'axios'
import Login from './Login.vue'
import numeral from 'numeral'

export default {
  data () {
    return {
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (this.invitedUsersArray.filter(item => { return item.email === value }).length === 0 && this.getUserOrganization.users.filter(item => { return item.email === value }).length === 0) {
            return pattern.test(value) || 'Invalid e-mail.'
          } else {
            return 'User email previously added.'
          }
        }
      },
      edit: false,
      editProject: null,
      photos: [],
      photosSearchQuery: '',
      name: null,
      description: null,
      status: 'Pending External Approval',
      config: {
        version: '0',
        rules: [''],
        newsapi: null,
        unsplashImageUrl: null
      },
      twitter: false,
      newsApi: false,
      users: [],
      userIds: [],
      step: 1,
      categories: [],
      isPublic: 0,
      diyPlan: null,
      successDialog: false,
      projectNameLoading: 'none',
      loading: false,
      display: 'diyStepper',
      sourcesDisplay: 'sourcesAdd',
      addTwitterDialog: false,
      unsplashImageUrl: null,
      twitterUsers: [],
      twitterUsersField: '',
      mentions: [],
      mentionsField: '',
      hashtags: [],
      hashtagsField: '',
      keywords: [],
      keywordsField: '',
      location: [],
      locationField: '',
      language: [],
      languageField: '',
      retweetsOnly: false,
      quotesOnly: false,
      verifiedOnly: false,
      addTwitterDialogDisplay: 'simple',
      twitterAdvancedRules: [],
      newsApiRule: '',
      savedNewsApiRule: '',
      addNewsApiDialog: false,
      usersAddDialog: false,
      selectedUsers: [],
      addUserDialogDisplay: 'add',
      invitedUsers: [
        {
          email: '',
          isAdmin: false
        }
      ],
      twitterRules: {
        twitterUsers: [],
        mentions: [],
        hashtags: [],
        keywords: [],
        location: [],
        language: [],
        retweetsOnly: false,
        verifiedOnly: false,
        quotesOnly: false,
        twitterAdvancedRules: []
      },
      invitedUsersArray: [],
      summaryDialog: false
    }
  },
  components: {
    Login
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization',
      getProjectCategories: 'getProjectCategories',
      getDiyPlans: 'getDiyPlans',
      getSubscriptionPlans: 'getSubscriptionPlans',
      getRoleByName: 'getRoleByName',
      getPlanById: 'getPlanById',
      getRoleById: 'getRoleById',
      getRoles: 'getRoles'
    }),
    masterRoleId () {
      if (this.$store.getters['getRoleByName']('MASTER_ROLE')) {
        return this.$store.getters['getRoleByName']('MASTER_ROLE').id
      }
    },
    adminRoleId () {
      if (this.$store.getters['getRoleByName']('ADMIN_ROLE')) {
        return this.$store.getters['getRoleByName']('ADMIN_ROLE').id
      }
    },
    viewerRoleId () {
      if (this.$store.getters['getRoleByName']('VIEWER_ROLE')) {
        return this.$store.getters['getRoleByName']('VIEWER_ROLE').id
      }
    },
    getUsersByIds () {
      var users = []
      for (var u = 0; u < this.userIds.length; u++) {
        var user = this.getUserOrganization.users.find(item => { return this.userIds[u] === item.id })
        if (user) {
          users.push(user)
        }
      }
      return users
    },
    organizationAdminsWithoutCurrentUser () {
      if (this.currentUser && this.getUserOrganization && this.getUserOrganization.users && this.getUserOrganization.users.length > 0) {
        return this.getUserOrganization.users.filter(user => {
          return this.getUserOrganization.organizationUsers.filter(e => Number(this.currentUser.id) !== Number(e.userId) && Number(e.userId) === Number(user.id) && (Number(e.roleId) === Number(this.adminRoleId) || Number(e.roleId) === Number(this.masterRoleId))).length > 0
        })
      } else {
        return []
      }
    },
    organizationViewersWithoutCurrentUser () {
      if (this.currentUser && this.getUserOrganization && this.getUserOrganization.users && this.getUserOrganization.users.length > 0) {
        return this.getUserOrganization.users.filter(user => {
          return this.getUserOrganization.organizationUsers.filter(e => Number(this.currentUser.id) !== Number(e.userId) && Number(e.userId) === Number(user.id) && Number(e.roleId) !== Number(this.adminRoleId) && Number(e.roleId) !== Number(this.masterRoleId)).length > 0
        })
      } else {
        return []
      }
    },
    organizationUsers () {
      if (this.currentUser && this.getUserOrganization && this.getUserOrganization.users && this.getUserOrganization.users.length > 0) {
        var users = []
        for (var u = 0; u < this.getUserOrganization.users.length; u++) {
          if (this.getUserOrganization.users[u].active) {
            users.push(this.getUserOrganization.users[u])
          }
        }
        var self = this
        var index = users.findIndex(function (user) {
          return user.id === self.currentUser.id
        })
        return users.splice(index - 1, 1)
      }
    },
    configNewsapi () {
      return this.config.newsapi
    },
    nameErrorMsgs () {
      if (this.$v.name.$dirty) {
        return vh.vmsg(this.$v.name, name)
      } else {
        return []
      }
    },
    descriptionErrorMsgs () {
      if (this.$v.description.$dirty) {
        return vh.vmsg(this.$v.description, description)
      } else {
        return []
      }
    },
    configNewsapiErrorMsgs () {
      if (this.$v.configNewsapi.$dirty) {
        return vh.vmsg(this.$v.configNewsapi, configNewsapi)
      } else {
        return []
      }
    },
    isAdmin () {
      return this.isLoggedIn && this.currentUser && this.getUserOrganization && this.getRoles.length > 0 && this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId !== this.getRoleByName('VIEWER_ROLE').id
    },
    isMaster () {
      return this.currentUser && this.getRoles.length > 0 && Number(this.getRoleByName('MASTER_ROLE').id) === Number(this.currentUser.defaultRoleId)
    },
    numberOfUsers () {
      return (this.userIds.length + this.invitedUsersArray.length + 1)
    },
    getAllUsers () {
      var users = []
      var currentUserName = this.currentUser.firstName + ' ' + this.currentUser.lastName
      users.push(currentUserName)
      var self = this
      this.userIds.forEach(function (id) {
        var u = self.getUserOrganization.users.find(item => { return item.id === id })
        if (u) {
          var name = u.firstName + ' ' + u.lastName
          users.push(name)
        }
      })
      this.invitedUsersArray.forEach(function (i) {
        users.push(i.email)
      })
      return users
    }
  },
  validations: {
    name: vh.vrules(name),
    description: vh.vrules(description),
    configNewsapi: vh.vrules(configNewsapi)
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    getNumber (number) {
      return number >= 0 ? this.formatNumber(number) : 'Unlimited'
    },
    searchForPhotos () {
      if (this.photosSearchQuery.length > 2) {
        let appid = this.$unsplash._applicationId
        let query = encodeURIComponent(this.photosSearchQuery)
        axios.get('https://api.unsplash.com/search/photos?page=1&per_page=12&query=' + query + '&client_id=' + appid).then(response => {
          this.photos = response.data.results
        }).catch(e => {
          console.log(e)
        })
      }
    },
    searchForPhotosWithQuery (query) {
      if (query.length > 2) {
        let appid = this.$unsplash._applicationId
        axios.get('https://api.unsplash.com/search/photos?page=1&per_page=12&query=' + encodeURIComponent(query) + '&client_id=' + appid).then(response => {
          this.photos = response.data.results
        }).catch(e => {
          console.log(e)
        })
      }
    },
    removeNewsApi () {
      this.savedNewsApiRule = ''
      this.newsApiRule = ''
      this.newsApi = false
    },
    removeTwitter () {
      this.twitterUsers = []
      this.twitterRules.twitterUsers = []
      this.mentions = []
      this.twitterRules.mentions = []
      this.hashtags = []
      this.twitterRules.hashtags = []
      this.keywords = []
      this.twitterRules.keywords = []
      this.location = []
      this.twitterRules.location = []
      this.language = []
      this.twitterRules.language = []
      this.twitterAdvancedRules = []
      this.twitterRules.twitterAdvancedRules = []
      this.twitter = false
      this.addTwitterDialogDisplay = 'simple'
    },
    openTwitterDialog () {
      this.twitterUsers = JSON.parse(JSON.stringify(this.twitterRules.twitterUsers))
      this.mentions = JSON.parse(JSON.stringify(this.twitterRules.mentions))
      this.hashtags = JSON.parse(JSON.stringify(this.twitterRules.hashtags))
      this.keywords = JSON.parse(JSON.stringify(this.twitterRules.keywords))
      this.location = JSON.parse(JSON.stringify(this.twitterRules.location))
      this.language = JSON.parse(JSON.stringify(this.twitterRules.language))
      this.retweetsOnly = JSON.parse(JSON.stringify(this.twitterRules.retweetsOnly))
      this.quotesOnly = JSON.parse(JSON.stringify(this.twitterRules.quotesOnly))
      this.verifiedOnly = JSON.parse(JSON.stringify(this.twitterRules.verifiedOnly))
      this.twitterAdvancedRules = JSON.parse(JSON.stringify(this.twitterRules.twitterAdvancedRules))
      this.addTwitterDialog = true
    },
    addTwitterSource (type) {
      if (this.twitterUsers.length > 0 || this.mentions.length > 0 || this.hashtags.length > 0 || this.keywords.length > 0 || this.location.length > 0 || this.language.length > 0 || this.twitterAdvancedRules.length > 0) {
        if (type === 'simple') {
          this.twitterRules.twitterUsers = JSON.parse(JSON.stringify(this.twitterUsers))
          this.twitterRules.mentions = JSON.parse(JSON.stringify(this.mentions))
          this.twitterRules.hashtags = JSON.parse(JSON.stringify(this.hashtags))
          this.twitterRules.keywords = JSON.parse(JSON.stringify(this.keywords))
          this.twitterRules.location = JSON.parse(JSON.stringify(this.location))
          this.twitterRules.language = JSON.parse(JSON.stringify(this.language))
          this.twitterRules.retweetsOnly = JSON.parse(JSON.stringify(this.retweetsOnly))
          this.twitterRules.quotesOnly = JSON.parse(JSON.stringify(this.quotesOnly))
          this.twitterRules.verifiedOnly = JSON.parse(JSON.stringify(this.verifiedOnly))
          this.twitterRules.twitterAdvancedRules = []
        } else {
          this.twitterRules.twitterUsers = []
          this.twitterRules.mentions = []
          this.twitterRules.hashtags = []
          this.twitterRules.keywords = []
          this.twitterRules.location = []
          this.twitterRules.language = []
          this.twitterRules.retweetsOnly = false
          this.twitterRules.quotesOnly = false
          this.twitterRules.verifiedOnly = false
          this.twitterRules.twitterAdvancedRules = JSON.parse(JSON.stringify(this.twitterAdvancedRules))
        }
        this.addTwitterDialog = false
        this.twitter = true
        this.sourcesDisplay = 'sourcesAdd'
        this.clearTwitterForms()
      } else {
        this.notify({message: 'You must specify at least one rule.', show: true})
      }
    },
    addNewsApi () {
      if (this.newsApiRule !== '') {
        this.savedNewsApiRule = this.newsApiRule
        this.newsApi = true
        this.addNewsApiDialog = false
        this.sourcesDisplay = 'sourcesAdd'
      } else {
        this.notify({message: 'Rule cannot be empty.', show: true})
      }
    },
    handleCategories (category) {
      if (this.categories.indexOf(category) === -1) {
        this.categories.push(category)
        this.searchForPhotosWithQuery(this.categories.join(' '))
      } else {
        this.categories.splice(this.categories.indexOf(category), 1)
        this.searchForPhotosWithQuery(this.categories.join(' '))
      }
    },
    inviteUsers () {
      var invalid = false
      for (var f = 0; f < this.invitedUsers.length; f++) {
        if (!this.$refs['userInvitationEmailField_' + (f)][0].validate(true)) {
          invalid = true
        }
      }
      if (!invalid) {
        this.invitedUsersArray = this.invitedUsersArray.concat(this.invitedUsers)
        this.invitedUsers = [{email: '', isAdmin: false}]
        this.usersAddDialog = false
        this.addUserDialogDisplay = 'add'
      }
    },
    addNewEmailInvitationField () {
      if (this.$refs['userInvitationEmailField_' + (this.invitedUsers.length - 1)][0].validate(true)) {
        this.invitedUsers.push({email: '', isAdmin: false})
      }
    },
    getUserRoleId (id) {
      return this.getRoleById(this.getUserOrganization.organizationUsers.find(item => { return item.userId === id }).roleId).id
    },
    getUserRole (id) {
      return this.getRoleById(this.getUserOrganization.organizationUsers.find(item => { return item.userId === id }).roleId).displayName
    },
    saveUsers () {
      this.selectedUsers = []
      for (var u = 0; u < this.userIds.length; u++) {
        this.selectedUsers.push(this.organizationUsers.find(item => { return item.id === this.userIds[u] }))
      }
      this.usersAddDialog = false
    },
    clearTwitterForms () {
      this.twitterUsers = []
      this.twitterUsersField = ''
      this.mentions = []
      this.mentionsField = ''
      this.hashtags = []
      this.hashtagsField = ''
      this.keywords = []
      this.keywordsField = ''
      this.location = []
      this.locationField = ''
      this.language = []
      this.languageField = ''
      this.retweetsOnly = false
      this.quotesOnly = false
      this.verifiedOnly = false
      this.addTwitterDialog = false
      this.twitterAdvancedRules = []
    },
    switchToAdvancedTwitterDisplay () {
      if (this.addTwitterDialogDisplay === 'simple') {
        this.addTwitterDialogDisplay = 'advanced'
      }
    },
    switchToSimpleTwitterDisplay () {
      if (this.addTwitterDialogDisplay === 'advanced') {
        this.addTwitterDialogDisplay = 'simple'
      }
    },
    getBorderBottom (step) {
      return step <= this.step ? 'borderBottomHighlight' : ''
    },
    handleTwitterUsersChips (value) {
      this.twitterUsers.splice(this.twitterUsers.indexOf(value), 1)
    },
    addTwitterUser () {
      if (this.twitterUsersField !== '' && this.twitterUsers.indexOf(this.twitterUsersField) === -1 && this.twitterUsers.length <= 10) {
        this.twitterUsers.push('from:' + this.twitterUsersField.replace(/ /g, '').replace(/@/g, ''))
      }
      this.twitterUsersField = ''
    },
    handleMentionsChips (value) {
      this.mentions.splice(this.mentions.indexOf(value), 1)
    },
    addMention () {
      if (this.mentionsField !== '' && this.mentions.indexOf(this.mentionsField) === -1 && this.mentions.length <= 10) {
        if (this.mentionsField.charAt(0) === '@') {
          this.mentions.push(this.mentionsField)
        } else {
          this.mentions.push('@' + this.mentionsField.replace(/ /g, ''))
        }
        this.mentionsField = ''
      }
    },
    handleHashtagsChips (value) {
      this.hashtags.splice(this.hashtags.indexOf(value), 1)
    },
    addHashtag () {
      if (this.hashtagsField !== '' && this.hashtags.indexOf(this.hashtagsField) === -1 && this.hashtags.length <= 10) {
        if (this.hashtagsField.charAt(0) === '#') {
          this.hashtags.push(this.hashtagsField)
        } else {
          this.hashtags.push('#' + this.hashtagsField.replace(/ /g, ''))
        }
        this.hashtagsField = ''
      }
    },
    handleKeywordsChips (value) {
      this.keywords.splice(this.keywords.indexOf(value), 1)
    },
    addKeyword () {
      if (this.keywordsField !== '' && this.keywords.indexOf(this.keywordsField) === -1 && this.keywords.length <= 10) {
        this.keywords.push(this.keywordsField.replace(/ /g, ''))
        this.keywordsField = ''
      }
    },
    handleLocationChips (value) {
      this.location.splice(this.location.indexOf(value), 1)
    },
    addLocation () {
      if (this.locationField !== '' && this.location.indexOf(this.locationField) === -1 && this.location.length <= 10) {
        this.location.push('place:' + this.locationField.replace(/ /g, ''))
        this.locationField = ''
      }
    },
    handleLanguageChips (value) {
      this.language.splice(this.language.indexOf(value), 1)
    },
    addLanguage () {
      if (this.languageField !== '' && this.language.indexOf(this.languageField) === -1 && this.language.length <= 10) {
        this.language.push('lang:' + this.languageField.replace(/ /g, ''))
        this.languageField = ''
      }
    },
    validateProjectName () {
      this.projectNameLoading = 'loading'
      axios.all([this.$store.dispatch('getProjectByName', {name: this.name})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          // this.notify({message: 'Project name already in use, please choose a different name.', show: true})
          if (!this.edit) {
            this.projectNameLoading = 'invalid'
          } else if (this.name === this.editProject.name) {
            this.projectNameLoading = 'valid'
          }
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        if (err.response.status === 400) {
          this.projectNameLoading = 'valid'
        } else {
          this.projectNameLoading = 'none'
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        }
      })
    },
    getPeriod (tierPeriod) {
      if (tierPeriod === 'MONTHLY') {
        return 'mo'
      } else if (tierPeriod === 'QUARTERLY') {
        return 'qt'
      } else if (tierPeriod === 'YEARLY') {
        return 'yr'
      } else {
        return ''
      }
    },
    editTwitter () {
      this.openTwitterDialog()
    },
    editNewsApi () {
      this.newsApiRule = this.savedNewsApiRule
      this.addNewsApiDialog = true
    },
    validateGNIPRule (rule, index) {
    },
    resetPage () {
      this.name = null
      this.description = null
      this.config = {
        version: '0',
        rules: [''],
        newsapi: null
      }
      this.twitter = false
      this.newsApi = false
      this.users = []
      this.userIds = []
      this.step = 1
      this.categories = []
      this.status = 'Pending External Approval'
      this.diyPlan = this.getDiyPlans.length > 0 ? this.getDiyPlans[0].id : -1
      this.projectNameLoading = 'none'
      this.loading = false
      this.sourcesDisplay = 'sourcesAdd'
      this.addTwitterDialog = false
      this.twitterUsers = []
      this.twitterUsersField = ''
      this.mentions = []
      this.mentionsField = ''
      this.hashtags = []
      this.hashtagsField = ''
      this.keywords = []
      this.keywordsField = ''
      this.location = []
      this.locationField = ''
      this.language = []
      this.languageField = ''
      this.retweetsOnly = false
      this.quotesOnly = false
      this.verifiedOnly = false
      this.addTwitterDialogDisplay = 'simple'
      this.twitterAdvancedRules = []
      this.newsApiRule = ''
      this.savedNewsApiRule = ''
      this.addNewsApiDialog = false
      this.usersAddDialog = false
      this.selectedUsers = []
      this.addUserDialogDisplay = 'add'
      this.invitedUsers = [
        {
          email: '',
          isAdmin: false
        }
      ]
      this.twitterRules = {
        twitterUsers: [],
        mentions: [],
        hashtags: [],
        keywords: [],
        location: [],
        language: [],
        retweetsOnly: false,
        verifiedOnly: false,
        quotesOnly: false,
        twitterAdvancedRules: []
      }
      this.invitedUsersArray = []
    },
    updateProject () {
      this.users = []
      for (var u = 0; u < this.userIds.length; u++) {
        this.users.push(this.getUserOrganization.users.find(item => { return this.userIds[u] === item.id }))
      }
      this.users.push(this.currentUser)
      this.users = this.users.concat(this.organizationAdminsWithoutCurrentUser)

      if (this.twitter) {
        if (this.twitterAdvancedRules.length > 0) {
          this.config.rules = this.twitterRules.twitterAdvancedRules
        } else {
          this.config.twitterSimpleRules = true
          var rules = []
          if (this.twitterRules.twitterUsers.length > 0) {
            rules.push(this.twitterRules.twitterUsers.join(' OR '))
          }
          if (this.twitterRules.mentions.length > 0) {
            rules.push(this.twitterRules.mentions.join(' OR '))
          }
          if (this.twitterRules.hashtags.length > 0) {
            rules.push(this.twitterRules.hashtags.join(' OR '))
          }
          if (this.twitterRules.keywords.length > 0) {
            rules.push(this.twitterRules.keywords.join(' OR '))
          }
          if (this.twitterRules.location.length > 0) {
            rules.push(this.twitterRules.location.join(' OR '))
          }
          if (this.twitterRules.language.length > 0) {
            rules.push(this.twitterRules.language.join(' OR '))
          }
          this.config.rules = rules
        }
      }

      if (this.newsApi) {
        this.config.newsapi = this.savedNewsApiRule
      }

      if (this.editProject.status === 'Pending Organization Approval') {
        this.status = 'Pending External Approval'
      } else if (this.editProject.status.includes('Active')) {
        this.status = 'Active (Pending Changes Approval)'
      }

      var localConfig = Vue.util.extend({}, this.config)
      localConfig.rules = localConfig.rules.slice()
      localConfig.rules = localConfig.rules.filter(e => e)
      localConfig.categories = this.categories
      localConfig.unsplashImageUrl = this.unsplashImageUrl
      var project = {
        id: this.editProject.id,
        name: this.name,
        description: this.description,
        status: this.status,
        config: localConfig,
        isPublic: this.isPublic === 1,
        isCustom: false,
        isDiyBillable: Number(this.diyPlan.tier) !== 0,
        isSubscriptionBillable: true,
        createdByUserId: this.currentUser.id,
        createdByOrganizationId: this.getUserOrganization.id
      }
      axios.all([this.$store.dispatch('updateProject', project), this.$store.dispatch('deleteOrganizationsUsersProjectsByOrganizationIdAndProjectId', {organizationId: this.getUserOrganization.id, projectId: this.editProject.id})]).then(axios.spread((response, deleteResponse) => {
        if (response.data.status === 'SUCCESS' && deleteResponse.data.status === 'SUCCESS') {
          for (var u = 0; u < this.users.length; u++) {
            var user = this.users[u]
            var organizationUserProject = {
              organizationId: this.getUserOrganization.id,
              projectId: this.editProject.id,
              userId: user.id,
              status: this.status,
              roleId: this.getUserOrganization.organizationUsers.find(item => { return item.userId === user.id }).roleId
            }
            axios.all([this.$store.dispatch('addOrganizationUserProject', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
              if (orgUserProjectResponse.data.status === 'SUCCESS') {
                if (u >= this.users.length - 1) {
                  if (this.invitedUsersArray.length > 0 && this.invitedUsersArray[0].email !== '') {
                    this.sendUserInvitations(this.editProject.id)
                  } else {
                    this.getOrganizationData()
                    this.resetPage()
                    this.summaryDialog = false
                    this.successDialog = true
                    this.loading = false
                  }
                }
                this.getOrganizationData()
              } else {
                this.loading = false
                this.notify({message: 'Something went wrong.', show: true})
              }
            })).catch((err) => {
              this.loading = false
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          }
        } else {
          this.loading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    async createProject () {
      this.users = []
      for (var u = 0; u < this.userIds.length; u++) {
        this.users.push(this.getUserOrganization.users.find(item => { return this.userIds[u] === item.id }))
      }
      this.users.push(this.currentUser)
      this.users = this.users.concat(this.organizationAdminsWithoutCurrentUser)

      if (this.twitter) {
        if (this.twitterAdvancedRules.length > 0) {
          this.config.rules = this.twitterRules.twitterAdvancedRules
        } else {
          this.config.twitterSimpleRules = true
          var rules = []
          if (this.twitterRules.twitterUsers.length > 0) {
            rules.push(this.twitterRules.twitterUsers.join(' OR '))
          }
          if (this.twitterRules.mentions.length > 0) {
            rules.push(this.twitterRules.mentions.join(' OR '))
          }
          if (this.twitterRules.hashtags.length > 0) {
            rules.push(this.twitterRules.hashtags.join(' OR '))
          }
          if (this.twitterRules.keywords.length > 0) {
            rules.push(this.twitterRules.keywords.join(' OR '))
          }
          if (this.twitterRules.location.length > 0) {
            rules.push(this.twitterRules.location.join(' OR '))
          }
          if (this.twitterRules.language.length > 0) {
            rules.push(this.twitterRules.language.join(' OR '))
          }
          this.config.rules = rules
        }
      }
      if (this.newsApi) {
        this.config.newsapi = this.savedNewsApiRule
      }

      var localConfig = Vue.util.extend({}, this.config)
      localConfig.rules = localConfig.rules.slice()
      localConfig.rules = localConfig.rules.filter(e => e)
      localConfig.categories = this.categories
      localConfig.unsplashImageUrl = this.unsplashImageUrl

      if (this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId === this.getRoleByName('VIEWER_ROLE').id) {
        this.status = 'Pending Organization Approval'
      }

      var project = {
        name: this.name,
        description: this.description,
        status: this.status,
        config: localConfig,
        isPublic: this.isPublic === 1,
        isCustom: false,
        isDiyBillable: Number(this.diyPlan.tier) !== 0,
        isSubscriptionBillable: true,
        createdByUserId: this.currentUser.id,
        createdByOrganizationId: this.getUserOrganization.id
      }
      axios.all([this.$store.dispatch('addProject', project)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          var organizationProject = {
            projectId: response.data.payload.id,
            organizationId: response.data.payload.createdByOrganizationId,
            planId: this.diyPlan,
            type: 'DIY',
            status: this.status
          }
          this.createRelations(organizationProject)
        } else {
          this.loading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    createRelations (organizationProject) {
      axios.all([this.$store.dispatch('addOrganizationProject', organizationProject)]).then(axios.spread((orgProjectResponse) => {
        if (orgProjectResponse.data.status === 'SUCCESS') {
          for (var u = 0; u < this.users.length; u++) {
            var user = this.users[u]
            var organizationUserProject = {
              organizationId: orgProjectResponse.data.payload.organizationId,
              projectId: orgProjectResponse.data.payload.projectId,
              userId: user.id,
              status: 'Pending External Approval',
              roleId: this.getUserOrganization.organizationUsers.find(item => { return item.userId === user.id }).roleId
            }
            axios.all([this.$store.dispatch('addOrganizationUserProject', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
              if (orgUserProjectResponse.data.status === 'SUCCESS') {
                if (u >= this.users.length - 1) {
                  if (this.invitedUsersArray.length > 0 && this.invitedUsersArray[0].email !== '') {
                    this.sendUserInvitations(orgProjectResponse.data.payload.projectId)
                  } else {
                    this.getOrganizationData()
                    this.resetPage()
                    this.summaryDialog = false
                    this.successDialog = true
                    this.loading = false
                  }
                }
                this.getOrganizationData()
              } else {
                this.loading = false
                this.notify({message: 'Something went wrong.', show: true})
              }
            })).catch((err) => {
              this.loading = false
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          }
        } else {
          this.loading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.loading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    sendUserInvitations (projectId) {
      for (var u = 0; u < this.invitedUsersArray.length; u++) {
        var role = this.invitedUsersArray[u].isAdmin ? this.getRoleByName('ADMIN_ROLE').id : this.getRoleByName('VIEWER_ROLE').id
        var invitationObject = {
          userId: this.currentUser.id,
          organizationId: this.getUserOrganization.id,
          organizationRoleId: role,
          projectRoleId: role,
          emails: [this.invitedUsersArray[u].email],
          projectIds: [Number(projectId)]
        }
        axios.all([this.$store.dispatch('inviteUsers', invitationObject)]).then(axios.spread((response) => {
          if (response.data.status === 'SUCCESS') {
            this.summaryDialog = false
            this.successDialog = true
            this.resetPage()
            this.getOrganizationData()
            this.loading = false
          } else {
            this.notify({message: 'Something went wrong while inviting new users.', show: true})
            this.loading = false
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loading = false
          console.log(err)
        })
      }
    },
    getOrganizationData () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.getUserOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    submit () {
      this.loading = true
      if (this.edit) {
        this.updateProject()
      } else {
        this.createProject()
      }
    },
    getProjectData (id) {
      this.loading = true
      axios.all([this.$store.dispatch('getProjectWithAllById', {id: Number(id)})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data.payload.createdByOrganizationId === this.getUserOrganization.id) {
            this.edit = true
            this.editProject = response.data.payload
            this.name = response.data.payload.name
            this.description = response.data.payload.description
            this.config = response.data.payload.config
            this.twitter = response.data.payload.config.rules.length > 0
            this.newsApi = response.data.payload.config.newsapi !== '' && response.data.payload.config.newsapi !== undefined
            this.categories = response.data.payload.config.categories
            this.status = 'Pending External Approval'
            this.savedNewsApiRule = response.data.payload.config.newsapi
            this.twitterUsers = []
            this.twitterUsersField = ''
            this.mentions = []
            this.mentionsField = ''
            this.hashtags = []
            this.hashtagsField = ''
            this.keywords = []
            this.keywordsField = ''
            this.location = []
            this.locationField = ''
            this.language = []
            this.languageField = ''
            this.userIds = []
            if (response.data.payload.config.twitterSimpleRules) {
              this.twitterRules = {
                twitterUsers: [],
                mentions: [],
                hashtags: [],
                keywords: [],
                location: [],
                language: [],
                retweetsOnly: false,
                verifiedOnly: false,
                quotesOnly: false,
                twitterAdvancedRules: []
              }
              for (var r = 0; r < response.data.payload.config.rules.length; r++) {
                var rule = response.data.payload.config.rules[r]
                if (rule.indexOf('@') === 0) {
                  this.twitterRules.mentions.push(rule)
                  this.mentions.push(rule)
                } else if (rule.indexOf('#') === 0) {
                  this.twitterRules.hashtags.push(rule)
                  this.hashtags.push(rule)
                } else if (rule.indexOf('from:') === 0) {
                  this.twitterRules.twitterUsers.push(rule)
                  this.twitterUsers.push(rule)
                } else if (rule.indexOf('place:') === 0) {
                  this.twitterRules.location.push(rule)
                  this.location.push(rule)
                } else if (rule.indexOf('lang:') === 0) {
                  this.twitterRules.language.push(rule)
                  this.language.push(rule)
                } else {
                  this.twitterRules.keywords.push(rule)
                  this.keywords.push(rule)
                }
              }
            } else {
              this.twitterRules = {
                twitterUsers: [],
                mentions: [],
                hashtags: [],
                keywords: [],
                location: [],
                language: [],
                retweetsOnly: false,
                verifiedOnly: false,
                quotesOnly: false,
                twitterAdvancedRules: response.data.payload.config.rules
              }
            }
            for (var u = 0; u < response.data.payload.users.length; u++) {
              if (response.data.payload.users[u].id !== this.currentUser.id) {
                this.userIds.push(response.data.payload.users[u].id)
              }
            }
            this.diyPlan = this.getPlanById(response.data.payload.projectOrganizations[0].planId).id
            this.isPublic = response.data.payload.isPublic ? 1 : 0
            this.projectNameLoading = 'valid'
            this.loading = false
          }
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  mounted () {
    this.resetPage()
    if (this.getDiyPlans.length > 0) {
      this.diyPlan = this.getDiyPlans[0].id
    }
    if (this.$route.query.display && this.$route.query.display === 'edit' && this.$route.query.project && this.$route.query.project !== '') {
      this.getProjectData(this.$route.query.project)
    } else {
      this.edit = false
      this.editProject = null
    }
  },
  watch: {
    getDiyPlans: function (newVal, oldVal) {
      if (this.getDiyPlans.length > 0) {
        this.diyPlan = this.getDiyPlans[0].id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DIY.vue